import { Cookies } from '@grandvisionhq/lib-cookies';
import { isLocalizedRequest } from './types.js';

/**
 * Utility functions to manage all the Locale related tasks
 */ const LOCALE_REGEX = /[a-z]{2}(_|-)[A-Z]{2}/g // Regex to validate locale from a string input
;
const LOCALE_COOKIE_NAME = 'selected_locale' // Cookie name to store the locale setting in a browser cookie
;
function getLocale(req, defaultLocale, isCmsPreview = false) {
    const locale = isLocalizedRequest(req) ? isCmsPreview ? getLocaleFromUrl(req.url) : getLocaleFromUrlOrReq(req) : defaultLocale;
    return locale || defaultLocale;
}
function getLocaleFromUrlOrReq(req) {
    return getLocaleFromUrl(req.url) || getLocaleFromRequest(req);
}
function getLocaleFromRequest(req) {
    return req && req.locale && `${req.locale.language}-${req.locale.region}`;
}
function getLocaleFromCookie() {
    return Cookies.get(LOCALE_COOKIE_NAME);
}
function getLocaleFromUrl(url) {
    const urlWithoutParams = url && url.split('?')[0];
    const locale = urlWithoutParams && urlWithoutParams.split('/').find((part)=>isValidLocale(part)
    );
    return locale && locale.replace('_', '-');
}
function setLocaleToCookie(locale) {
    const expiryDate = new Date(Date.now());
    expiryDate.setFullYear(expiryDate.getFullYear() + 2);
    Cookies.set(LOCALE_COOKIE_NAME, locale, {
        expires: expiryDate
    });
}
function isValidLocale(locale) {
    return !!locale.match(LOCALE_REGEX) && locale.length === 5;
}
function getLocaleSwitchPath(basePath) {
    const urlParts = window.location.href.split('?');
    return urlParts && urlParts.length > 1 ? `${basePath}?${urlParts[1]}` : basePath;
}

export { LOCALE_COOKIE_NAME, LOCALE_REGEX, getLocale, getLocaleFromCookie, getLocaleFromRequest, getLocaleFromUrl, getLocaleFromUrlOrReq, getLocaleSwitchPath, isValidLocale, setLocaleToCookie };
//# sourceMappingURL=locale-utils.js.map
